import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { buildReturnToPath } from './auth/returnTo';

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setChecking(false);
    });

    return () => unsubscribe();
  }, []);

  if (checking) return null; // Optional: Loading spinner

  return user ? children : (
    <Navigate
      to="/signin"
      replace
      state={{ returnTo: buildReturnToPath(location) }}
    />
  );
}

export default ProtectedRoute;
